function checkEmptyObject(value) {
  if (typeof value === 'object') {
    const objEntriesLength = Object.entries(value).length;

    if (objEntriesLength === 0) {
      return true;
    }

    const objEntries = Object.entries(value);
    return objEntries.every((entry) => !entry[1] || entry[1] === '' || entry[1] === 0);
  }
  return false;
};

function hasValue(value) {
  if (value === undefined || value === null) {
    return false;
  }

  if (typeof value === 'object') {
    return !checkEmptyObject(value);
  }

  return !(typeof value === 'string' && value.length === 0);
};

function toggleHasValue(el, binding) {
  const { value } = binding;
  const toggleClassEl = el.closest('.select-box-holder') || el;
  if (hasValue(value)) { toggleClassEl.classList.add('has-value'); } else { toggleClassEl.classList.remove('has-value'); }
}

export default {
  bind: toggleHasValue,
  update: toggleHasValue,
};
